import type { CityLiveFlightDirection } from "@/lib/api";

/** A whole count with grouping, so the estimate reads `16,240` in markup and hydration alike. */
export function formatCount(value: number): string {
  return new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 }).format(value);
}

/**
 * Today's arrivals as one figure and the wording that says it is an estimate, or
 * null when there is nothing honest to state.
 *
 * The guard is on the figure: `estimated_passengers` is nullable, so a full board
 * with no seat data sums to zero, and a row that says nobody is landing is a claim
 * where a blank one is not. Both surfaces that draw this reading — the guide
 * header's ARRIVALS cell and the directory row — read it here, so they can never
 * disagree on the number or on the sentence that qualifies it.
 */
export function readArrivals(
  direction: CityLiveFlightDirection | null | undefined,
): { label: string; hint: string } | null {
  if (!direction || direction.passengers <= 0) return null;
  return { label: formatCount(direction.passengers), hint: "Estimated passengers arriving today" };
}
